import { ThemeName } from "@components/atoms/Themed"
import { createContext, useContext, useEffect, useState } from "react"

type PageContextType = {
  theme: ThemeName
  setTheme: (theme: ThemeName) => void
  footerTheme?: ThemeName
  setFooterTheme?: (theme: ThemeName) => void
  introPlaying?: boolean
  setIntroPlaying?: (playing: boolean) => void
  introLogoPlaying?: boolean
  setIntroLogoPlaying?: (playing: boolean) => void
}

export const PageContext = createContext<PageContextType | undefined>(undefined)

export const PageProvider = ({
  initialTheme,
  children,
}: {
  initialTheme?: ThemeName | null
  children: React.ReactNode
}) => {
  const [theme, setTheme] = useState<ThemeName>(initialTheme || "none")
  const [footerTheme, setFooterTheme] = useState<ThemeName>(initialTheme || "none")
  const [introPlaying, setIntroPlaying] = useState<boolean>(false)
  const [introLogoPlaying, setIntroLogoPlaying] = useState<boolean>(false)

  useEffect(() => {
    setTheme((theme) => (theme === "none" ? initialTheme || "none" : theme))
  }, [])

  return (
    <PageContext.Provider
      value={{
        theme,
        setTheme,
        footerTheme,
        setFooterTheme,
        introPlaying,
        setIntroPlaying,
        introLogoPlaying,
        setIntroLogoPlaying,
      }}
    >
      {children}
    </PageContext.Provider>
  )
}

export const usePageContext = () => {
  const context = useContext(PageContext)
  // if (context === undefined && !env.admin) {
  //   throw new Error("usePageContext must be used within a PageProvider")
  // }
  return context || { theme: "none", setTheme: () => {}, footerTheme: "none", setFooterTheme: () => {} }
}

export function useSetTheme(theme: ThemeName | null | undefined) {
  const { setTheme } = usePageContext()

  useEffect(() => {
    setTheme?.(theme ?? "none")
  }, [theme])

  return theme ?? "none"
}

export function useSetFooterTheme(theme: ThemeName | null | undefined) {
  const { setFooterTheme } = usePageContext()

  useEffect(() => {
    setFooterTheme?.(theme ?? "none")
  }, [theme])

  return theme ?? "none"
}
